import type { AxiosResponse } from 'axios';
import { BaseService } from './baseService';
import axiosInstance from '../axiosInstance';

class UsersService extends BaseService<User, 'userID', 'users'> {
	constructor() {
		super('userID', 'user', 'users');
	}

	async getSelf(queryParams?: { [key: string]: string }): Promise<User> {
		const response: AxiosResponse<TavoittajaApiResponse<{ user: User }>> =
			await axiosInstance.get(`/app/users/self`, {
				params: {
					...queryParams,
				},
			});

		return response.data.data.user;
	}

	async deleteMultipleUsers(data: DeleteMultipleUsersRequest): Promise<void> {
		await axiosInstance.post(
			`/app/${this.crudResponseArrayName}/batch`,
			data,
		);
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new UsersService();
